/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Component for forecast correction factor input
 * @author Maarten Lensink

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[_ngcontent-%COMP%]{padding-left:4px!important;padding-right:4px!important}.sym-has-errors[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border:1px solid #d55b40}.sym-has-errors[_ngcontent-%COMP%]   .sym-input-feedback[_ngcontent-%COMP%]{color:#d55b40}.input-group-append[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none}.sym-enabled[_ngcontent-%COMP%]{opacity:1}span[_ngcontent-%COMP%]{line-height:27px}@media (min-width:992px){.input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;min-width:50px}}input[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
